/* src/app/modules/qr/qrcode.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
#innerbox {
  width: 640px;
  max-width: 480px;
  display: inline-block;
}
mat-toolbar {
  background: #42a5f5;
  color: white;
}
canvas {
  width: 100vw;
  height: calc(100vh - 57px);
}
.button-area {
  max-width: 100vw;
}
.qrtext {
  font-size: 22px;
  color: white;
  flex-grow: 1;
  width: 65%;
}
.flex-container {
  display: flex;
  flex-flow: row wrap;
}
.flex-container > div {
  margin: 10px;
  text-align: center;
}
.butonqr {
  margin: 0.5rem;
  margin-top: 1em;
  margin-right: 5%;
  border: 1px solid;
  color: white;
}
.helper {
  display: inline-block;
  vertical-align: middle;
}
.video-html-cam {
  width: 90%;
  display: block;
  margin: 0 auto;
}
@media (max-width: 991px) {
  .first-column {
    width: 100%;
  }
  .second-column {
    width: 100%;
  }
  .video-html-cam {
    width: 100%;
    display: inline-block;
    margin: initial;
  }
}
/*# sourceMappingURL=qrcode.component.css.map */
